<template>
  <div class="wrapper">
    <div class="main">
      <!-- 佔位符，當 navView 固定時，這個佔位符顯示出來 -->
      <div v-if="isFixed" :style="{ height: navHeight + 'px' }"></div>
      
      <div :class="{ fixed: isFixed, 'rounded-nav': isFixed }" ref="nav">
        <navView></navView>
      </div>
      
      <main class="content p-0">
        <breadcrumbView></breadcrumbView>
        <div>
          <router-view />
        </div>
      </main>
      <footerView></footerView>
    </div>
  </div>
</template>
  
<script>
import navView from '@/components/navView.vue'
import breadcrumbView from '@/components/breadcrumbView.vue'
import footerView from '@/components/footerView.vue'

export default {
  data(){
    return {
      isFixed: false,
      navHeight: 0,  // 用來存儲 navView 的高度
    }
  },
  components: {
    navView, breadcrumbView, footerView
  },
  mounted() {
    // 當 navView 加載後，獲取它的高度
    this.navHeight = this.$refs.nav.offsetHeight;

    // 添加滾動事件監聽
    window.addEventListener('scroll', this.handleScroll);
  },
  created(){
    console.log('created')
  },
  beforeCreate(){
    // console.log('beforeCreate')
    // const userData = this.$api.users.getUserData()
    // if (!userData){
    //   this.$router.push('/login')
    //   return
    // }
  },
  beforeUnmount() {
    // 移除滾動事件監聽
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      const scrollPosition = window.scrollY || window.pageYOffset;
      // 假設滾動高度大於 0 時固定 navView
      this.isFixed = scrollPosition > 0;
    }
  },
};
</script>

<style scoped>
.main {
  padding: 0 4rem;
}

.fixed {
  position: fixed;
  top: .5rem;
  left: 0;
  width: calc(100% - 2rem);
  z-index: 1000;
  padding: 0.5rem 4rem !important;
  margin: 0 1rem;
  background-color: #153d77;
  transition: all 0.3s ease-in-out;
}

.rounded-nav {
  border-radius: 10px; /* 倒圓角 */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25); /* 添加陰影以提高視覺效果 */
}

@media screen and (max-width: 1024px) {
  .main {
    padding: 0 1rem;
  }
}
@media (max-width: 767px) {
  .fixed{
    padding: 0.5rem 1.15rem !important;
  }
  .content{
    margin-top: 0.75rem;
  }
}
</style>
